import { formatDateTime } from "../../../users/adminUserFormatters";
import { formatFrameAge } from "../../../../../../utils/radarHealthAdminUtils";

function DiagnosticRow({ label, value }) {
  return (
    <div className="weather-radar-diagnostics__row">
      <span className="weather-radar-diagnostics__label">{label}</span>
      <span className="weather-radar-diagnostics__value">{value ?? "—"}</span>
    </div>
  );
}

const WeatherRadarBartDiagnosticsPanel = ({ bart, showDebugFields = false }) => {
  if (!bart) {
    return (
      <div className="admin-dash__card panel-card">
        <h2 className="admin-section-title">IDEAM BART diagnostics</h2>
        <p className="weather-radar-health-notice">No IDEAM BART health data is available.</p>
      </div>
    );
  }

  const apiBase = process.env.REACT_APP_API_BASE_URL || "";
  const frameUrl = bart.latestFramePublicUrl
    ? `${apiBase}${bart.latestFramePublicUrl}`
    : null;

  return (
    <div className="admin-dash__card panel-card weather-radar-diagnostics">
      <h2 className="admin-section-title">IDEAM BART diagnostics</h2>

      {bart.renderableFrameCount === 0 ? (
        <p className="weather-radar-health-notice" role="status">
          No renderable official radar frames are currently cached.
        </p>
      ) : null}

      <div className="weather-radar-diagnostics__grid">
        <DiagnosticRow label="Directory reachable" value={bart.directoryReachable ? "Yes" : "No"} />
        <DiagnosticRow label="Cache writable" value={bart.cacheWritable ? "Yes" : "No"} />
        <DiagnosticRow
          label="Latest discovered frame"
          value={bart.latestDiscoveredFrameTime ? formatDateTime(bart.latestDiscoveredFrameTime) : "—"}
        />
        <DiagnosticRow
          label="Latest cached frame"
          value={bart.latestCachedFrameTime ? formatDateTime(bart.latestCachedFrameTime) : "—"}
        />
        <DiagnosticRow
          label="Latest renderable frame"
          value={bart.latestRenderableFrameTime ? formatDateTime(bart.latestRenderableFrameTime) : "—"}
        />
        <DiagnosticRow label="Latest frame age" value={formatFrameAge(bart.latestFrameAgeMinutes)} />
        <DiagnosticRow label="Discovered frames" value={bart.discoveredFrameCount} />
        <DiagnosticRow label="Cached frames" value={bart.cachedFrameCount} />
        <DiagnosticRow label="Renderable frames" value={bart.renderableFrameCount} />
        <DiagnosticRow label="Invalid frames" value={bart.invalidFrameCount} />
        <DiagnosticRow label="Failed downloads" value={bart.failedDownloadCount} />
        <DiagnosticRow
          label="Last discovery"
          value={bart.lastDiscoveryAt ? formatDateTime(bart.lastDiscoveryAt) : "—"}
        />
        <DiagnosticRow
          label="Last sync"
          value={bart.lastSyncAt ? formatDateTime(bart.lastSyncAt) : "—"}
        />
        <DiagnosticRow
          label="Last successful download"
          value={bart.lastSuccessfulDownloadAt ? formatDateTime(bart.lastSuccessfulDownloadAt) : "—"}
        />
        <DiagnosticRow label="Last error" value={bart.lastError || "—"} />
        {showDebugFields ? (
          <>
            <DiagnosticRow label="Cache directory" value={bart.cacheDirectory || "—"} />
            <DiagnosticRow
              label="Latest cached frame URL"
              value={
                frameUrl ? (
                  <a href={frameUrl} target="_blank" rel="noreferrer">
                    {bart.latestFramePublicUrl}
                  </a>
                ) : (
                  "—"
                )
              }
            />
          </>
        ) : null}
      </div>
    </div>
  );
};

export default WeatherRadarBartDiagnosticsPanel;
